module.exports = __webpack_public_path__ + "static/img/nxcy.9b8678b8.png";